import Phaser from 'phaser';
import { AppShell } from './components/AppShell';
import { loadRuntimeConfig } from './config/gameConfig';
import { AttractScene } from './game/scenes/AttractScene';
import { BootScene } from './game/scenes/BootScene';
import { GAME_HEIGHT, GAME_WIDTH, GameScene } from './game/scenes/GameScene';
import { CommunityScene } from './game/scenes/CommunityScene';
import { InstructionsScene } from './game/scenes/InstructionsScene';
import { LeaderboardScene } from './game/scenes/LeaderboardScene';
import { ResultsScene } from './game/scenes/ResultsScene';
import { appUpdateManager } from './game/systems/AppUpdateSystem';
import { performEventReadyMigration } from './game/systems/StorageSystem';
import './styles/main.css';

async function bootstrap(): Promise<void> {
  const ui = document.querySelector<HTMLElement>('#ui-layer');
  const liveRegion = document.querySelector<HTMLElement>('#live-region');
  if (!ui || !liveRegion) throw new Error('The game interface could not be created.');

  const runtimeConfig = await loadRuntimeConfig();
  performEventReadyMigration();
  const shell = new AppShell(ui, liveRegion, runtimeConfig);
  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent: 'game',
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    backgroundColor: '#06152f',
    scene: [BootScene, AttractScene, InstructionsScene, CommunityScene, GameScene, ResultsScene, LeaderboardScene],
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: GAME_WIDTH,
      height: GAME_HEIGHT,
    },
    render: { antialias: true, pixelArt: false, roundPixels: true },
    input: { keyboard: true, gamepad: true, touch: true },
    audio: { disableWebAudio: true },
  });
  shell.attachGame(game);
  void appUpdateManager.start();

  window.addEventListener('error', (event) => {
    if (event.error instanceof Error) shell.showRecovery(event.error.message);
  });
  window.addEventListener('unhandledrejection', (event) => {
    const message = event.reason instanceof Error ? event.reason.message : 'An unexpected connection error occurred.';
    shell.showRecovery(message);
  });

}

void bootstrap().catch((error: unknown) => {
  const message = error instanceof Error ? error.message : 'The game could not start.';
  const ui = document.querySelector<HTMLElement>('#ui-layer');
  if (ui) ui.innerHTML = `<section class="recovery-panel" role="alert"><h1>Let’s reconnect the game.</h1><p>${message}</p><button onclick="location.reload()">Reload game</button></section>`;
});
